/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 可用礼品卡
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class SelTranslateGiftCardParams {
  constructor(public productId: string, public showId: number) {}
}

export default async function (
  params: SelTranslateGiftCardParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.GiftCardRes>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/translate`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
